/**
 * @generated SignedSource<<09b2aa2c07623995a523120673db815b>>
 * @relayHash 4d12954ae7175b8d9c1894c9dcbe7c05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3514f351421b9ab4947c7ba451435d6de5703d425ef0ce26c2ca48d69d4f9d57

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAtlassianIntelligenceFeatureEnum = "AI_MATE" | "NATURAL_LANGUAGE_TO_JQL" | "%future added value";
export type JiraBoardSwimlaneStrategy = "ASSIGNEE_UNASSIGNED_FIRST" | "ASSIGNEE_UNASSIGNED_LAST" | "CUSTOM" | "EPIC" | "ISSUE_CHILDREN" | "ISSUE_PARENT" | "NONE" | "PARENT_CHILD" | "PROJECT" | "REQUEST_TYPE" | "TOWNSQUARE_PROJECT" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_BOARD" | "TIMELINE_PROJECT" | "%future added value";
export type JiraJqlScopeInput = {
  agentSessions?: JiraAgentSessionsScopeInput | null;
  backlog?: JiraJqlBacklogInput | null;
  board?: JiraJqlBoardInput | null;
  list?: JiraIssueSearchScope | null;
  plan?: JiraJqlPlanInput | null;
  project?: JiraJqlProjectInput | null;
};
export type JiraAgentSessionsScopeInput = {
  boardId?: string | null;
  jql?: string | null;
  spaceKey?: string | null;
};
export type JiraJqlBacklogInput = {
  boardId: AGG$Long;
};
export type JiraJqlBoardInput = {
  boardId: AGG$Long;
  swimlaneStrategy?: JiraBoardSwimlaneStrategy | null;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null;
  projectKey?: string | null;
};
export type JiraJqlPlanInput = {
  planId: AGG$Long;
  scenarioId?: AGG$Long | null;
};
export type JiraJqlProjectInput = {
  projectKey?: string | null;
};
export type FilterRefinementWithAiQuery$variables = {
  atlassianIntelligenceProductFeature: JiraAtlassianIntelligenceFeatureEnum;
  cloudId: string;
  scope?: JiraJqlScopeInput | null;
};
export type FilterRefinementWithAiQuery$data = {
  readonly jira: {
    readonly aiControls: {
      readonly " $fragmentSpreads": FragmentRefs<"AiControls_query">;
    };
    readonly filterRefinementQuery: {
      readonly " $fragmentSpreads": FragmentRefs<"FilterRefinement_query">;
    };
  } | null;
};
export type FilterRefinementWithAiQuery = {
  response: FilterRefinementWithAiQuery$data;
  variables: FilterRefinementWithAiQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "atlassianIntelligenceProductFeature"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scope"
},
v3 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v4 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v5 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FilterRefinementWithAiQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "assignees",
                      "value": 50
                    },
                    (v3/*: any*/),
                    (v4/*: any*/)
                  ],
                  "kind": "FragmentSpread",
                  "name": "FilterRefinement_query"
                }
              ],
              "type": "JiraQuery"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "filterRefinementQuery"
          },
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "AiControls_query"
                }
              ],
              "type": "JiraQuery"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "aiControls"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FilterRefinementWithAiQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v3/*: any*/)
            ],
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 50
                  },
                  {
                    "kind": "Literal",
                    "name": "jqlTerm",
                    "value": "assignee"
                  },
                  (v4/*: any*/)
                ],
                "concreteType": "JiraJqlFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "jqlTerm"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "appType"
                                      }
                                    ],
                                    "type": "AppUser"
                                  },
                                  (v6/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlUserFieldValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v6/*: any*/)
            ]
          },
          {
            "args": [
              {
                "fields": [
                  {
                    "kind": "Variable",
                    "name": "feature",
                    "variableName": "atlassianIntelligenceProductFeature"
                  }
                ],
                "kind": "ObjectValue",
                "name": "atlassianIntelligenceProductFeatureInput"
              },
              (v3/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "atlassianIntelligenceAction",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAccessible"
                  }
                ],
                "type": "JiraAccessAtlassianIntelligenceFeature"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "link"
                  }
                ],
                "type": "JiraEnableAtlassianIntelligenceDeepLink"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3514f351421b9ab4947c7ba451435d6de5703d425ef0ce26c2ca48d69d4f9d57",
    "metadata": {},
    "name": "FilterRefinementWithAiQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7a9adbeb91cb0d260b7fa9e706e839fc";

export default node;
